/* eslint-disable no-param-reassign */
import { GetServerSideProps } from 'next';
import { Fragment } from 'react';

import { wrapper } from 'src/redux/store/store';
import { getSimplePage } from 'src/api/pageApi';
import { PageSetUpInStorageConfig, ServerSideRenderingContext } from 'types/objectTypes';
import { CustomerType } from 'constants/enums';
import { calculateCustomerType } from 'lib/session.service';
import { setUpPageInStore } from 'lib/page.service';
import withMiddleware, { commonMiddleware, postCommonMiddleware } from 'src/shared/lib/middleware/combiner';

const handler = async (context: ServerSideRenderingContext): Promise<any> => {
  try {
    const {
      query,
      path,
      req,
      store,
      preview = false,
    } = context;

    const { slug } = query || {};

    if (!slug || Array.isArray(slug)) {
      return { notFound: true };
    }

    const session = req?.session?.getSession();
    const customerType = calculateCustomerType(req.session);
    const isAuthorized = customerType === CustomerType.EC;

    const page = await getSimplePage({
      slug,
      customerType,
      preview,
      path,
    });

    if (!page) {
      return { notFound: true };
    }

    const pageSetUpConfig: PageSetUpInStorageConfig = {
      page,
      session,
      slug,
      store,
      headers: req.headers,
      isAuthorized,
    };

    setUpPageInStore(pageSetUpConfig);

    return { props: {} };
  } catch (e) {
    console.error(e);

    return { notFound: true };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
  // @ts-ignore
  .getServerSideProps(withMiddleware(
    handler,
    { prior: commonMiddleware, post: postCommonMiddleware },
  ));

export default Fragment;
